/**
 * The file contents for the current environment will overwrite these during
 * build. The build system defaults to the dev environment which uses
 * `environment.ts`, but if you do `ng build --env=prod` then
 * `environment.prod.ts` will be used instead. The list of which env maps to
 * which file can be found in `angular-cli.json`. `.env.ts` is generated by the
 * `npm run env` command import env from './.env';
 */

/**
 * @ignore
 */
let production = 'true';
let serverUrl = 'https://ruckit-platform-dev.herokuapp.com/api/';
let imageServerUrl = 'http://ruckit-platform-dev.s3-website-us-east-1.amazonaws.com';
let resizeImageServerUrl = 'https://d2o05km0cx02l1.cloudfront.net';
let errorTrackingEnv = 'dev';
let googleMapsKey = 'AIzaSyBnyQsblAiJeVVAHKQyo76Nx8PVp-N2mLU';
let applicationVersion = '105a6b9cf245a6c8c3ff20cb3291f3c01d6e65a4';
let scaleitUrl = 'https://api.scaleitusa.com/api/ruckit/v1/';
let s3ServerUrl = 'https://s3.amazonaws.com/ruckit-platform-dev/';
let ticketManagerUrl = 'https://tickets-dev.goruckit.com';
let ordersUrl = 'https://lafarge-orders.goruckit.com';

export const environment = {
  production: production === 'true',
  serverUrl: serverUrl,
  imageServerUrl: imageServerUrl,
  resizeImageServerUrl: resizeImageServerUrl,
  s3ServerUrl: s3ServerUrl,
  scaleitUrl: scaleitUrl,
  ticketManagerUrl: ticketManagerUrl,
  ordersUrl: ordersUrl,
  errorTrackingEnv: errorTrackingEnv,
  applicationVersion: applicationVersion,
  defaultLanguage: 'en-US',
  supportedLanguages: [
    'en-US',
    'fr-FR'
  ],
  googleMapsKey: googleMapsKey
};
